export class ChangePassEventType {

	static SEND = {
		CHANGE_PASS_SEND: 'CHANGE_PASS_SEND',
		CHANGE_PASS_CONFIRM: 'CHANGE_PASS_CONFIRM'
	};

	static STEPS = {
		CHANGE_PASS_RESET_HOME: 'CHANGE_PASS_RESET_HOME',
		CHANGE_PASS_RESET: 'CHANGE_PASS_RESET',
		CHANGE_PASS_WARNING: 'CHANGE_PASS_WARNING'
	};

	static ERROR = 'CHANGE_PASS_ERROR';
	static BUTTONS = 'CHANGE_PASS_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-pass/change-pass.event.type.ts